import React from 'react';
import { bool } from 'prop-types';

import './loading.scss';

export const LoadingDepositCallout = ({ depositCalloutReduced }) => {
  return (
    <div className="loading-rental-deposit">
      {depositCalloutReduced ? (
        <div className="loading-container">
          <div className="loading-bar sm" />
        </div>
      ) : (
        <ul className="loading-container">
          <li className="loading-bar lg" />
          <li className="loading-bar sm" />
          <li className="loading-bar md" />
        </ul>
      )}
    </div>
  );
};

LoadingDepositCallout.displayName = 'LoadingDepositCallout';

LoadingDepositCallout.propTypes = {
  depositCalloutReduced: bool.isRequired
};